"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LocationImage;
var jsx_runtime_1 = require("react/jsx-runtime");
function LocationImage(_a) {
    var path = _a.path, alt = _a.alt, width = _a.width;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("img", { src: path, alt: alt, style: {
                width: width,
                height: "auto",
                border: "1px solid #ccc",
            } }) }));
}
